import React from 'react'
import PropTypes from 'prop-types'
import cn from 'comma-number'

import ContactAgentGeneric from 'Components/ContactAgentGeneric'

import { _PreconRequestInfo, _RequestInfoText, _PreconForSale, _NearbySchools } from './styles'


const PreconInsiderAccess = ({ agent, handleContactAgent, priceMin, priceMax, units, onInfoBoxAnchorClick, COLLAPSE_TYPES }) => {
  const hasPriceRange = (Number.isFinite(priceMin) && priceMin > 0) && (Number.isFinite(priceMax) && priceMax > 0)
  const content = units > 0 ? (
    <_PreconRequestInfo>
      <_RequestInfoText isBold>Selling Now</_RequestInfoText>
      <_RequestInfoText>
        {hasPriceRange ? `From $${cn(priceMin)} to $${cn(priceMax)}` : 'Contact for pricing'}
      </_RequestInfoText>
      <_PreconForSale
        secondary
        onClick={() => onInfoBoxAnchorClick(COLLAPSE_TYPES.FOR_SALE)}
      >
        <span>{units}&nbsp;</span> For Sale
      </_PreconForSale>
      <_NearbySchools
        onClick={() => onInfoBoxAnchorClick(COLLAPSE_TYPES.NEARBY_SCHOOLS)}
      >
        Nearby Schools
      </_NearbySchools>
    </_PreconRequestInfo>
  ) : (
    <_PreconRequestInfo>
      <_RequestInfoText isBold>Get insider access</_RequestInfoText>
      <_RequestInfoText>
        Contact us for pricing info, floor plans, incentives, amenities, and
        more!
      </_RequestInfoText>
      <ContactAgentGeneric
        agent={agent}
        handleContactAgent={handleContactAgent}
        gaCategory={'Building'}
        requestInfo
      />
    </_PreconRequestInfo>
  )

  return content
}


PreconInsiderAccess.propTypes = {
  building: PropTypes.shape({
    addresses_string: PropTypes.string,
    _geoloc: PropTypes.arrayOf(PropTypes.number),
    listings_for_sale_count: PropTypes.number,
    listings_for_rent_count: PropTypes.number,
    primary_address: PropTypes.shape({
      title: PropTypes.string,
    }),
    id: PropTypes.number,
    listings: PropTypes.shape({
      for_sale: PropTypes.arrayOf(PropTypes.shape({})),
      for_rent: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    developers: PropTypes.arrayOf(PropTypes.shape({})),
    url: PropTypes.string,
    name: PropTypes.string,
    address_name: PropTypes.string,
    locality_name: PropTypes.string,
    property_management: PropTypes.shape({
      name: PropTypes.string,
    }),
    developer: PropTypes.shape({
      name: PropTypes.string,
    }),
    corp: PropTypes.shape({
      corp_number: PropTypes.string,
      condo_corp: PropTypes.string,
    }),
    date_built: PropTypes.arrayOf(PropTypes.shape({})),
    smallest_unit: PropTypes.number,
    largest_unit: PropTypes.number,
    storeys: PropTypes.string,
    units: PropTypes.string,
    floorplan: PropTypes.number,
    dates: PropTypes.arrayOf(PropTypes.shape({
      exact_date: PropTypes.string,
    })),
    price_min: PropTypes.number,
    price_max: PropTypes.number,
    sales_status: PropTypes.string,
    construction_status: PropTypes.string,
    occupancy_date: PropTypes.string,
  }),
  agent: PropTypes.shape({}),
  priceMax: PropTypes.number,
  priceMin: PropTypes.number,
  units: PropTypes.number,
  handleContactAgent: PropTypes.func,
  saleStatus: PropTypes.string,
  onInfoBoxAnchorClick: PropTypes.func,
}

export default PreconInsiderAccess
